import * as XLSX from "xlsx";
import moment from "moment";

export default function exportMocsToExcel(mocs, fileName = "relatorio-mocs") {
    const rows = mocs.map((moc) => ({
        "Código do MOC": moc.codMoc || "",
        "Título do MOC": moc.title || "",
        "Status": moc.Steps?.name || "",
        "Modelo": moc.modelMoc || "",
        "Site": moc.Sites?.name || "",
        "Categoria": moc.Categories?.name || "",
        "Tipo": moc.Types?.name || "",
        "Solicitante": moc.Users?.name || "",
        "Data de abertura": moc.openDate ? moment.utc(moc.openDate).format("DD/MM/YYYY") : "",
        "Fiscal year de implementação": moc.fiscalYear ?? "",
        "Custo previsto": moc.initialBudget ?? "",
        "Apoio do HSE": moc.hseSupport ? "Sim" : "Não",
        "Descrição da mudança": moc.description || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    if (worksheet["!ref"]) {
        worksheet["!autofilter"] = { ref: worksheet["!ref"] };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MOCs");

    XLSX.writeFile(workbook, `${fileName}-${moment().format("YYYY-MM-DD")}.xlsx`);
}
